'use client'

import { createNavigationTelemetry } from '@brew/observability/browser'
import { pageCommit } from './page-commit'
import { pageContentReadiness } from './page-content-readiness'
import { pageReadiness } from './page-readiness'

const navigation = createNavigationTelemetry([
  'home',
  'chat',
  'emails',
  'automations',
  'campaigns',
  'contacts',
  'audience',
  'events',
  'analytics',
  'insights',
  'brand',
  'settings',
  'integrations',
  'onboarding',
  'setup',
  'plan',
  'sign-in',
  'sign-up',
])

export function beginNavigationTelemetry(url: string, type: string): void {
  navigation.begin(url, type)
  pageReadiness.begin(url, type)
  pageCommit.begin(url, type)
  pageContentReadiness.begin(url, type)
}
export const completeNavigationTelemetry = navigation.complete
